import { z } from 'zod';
/** Pieces more than one artifact schema is built from. */
export const stopKindSchema = z.enum(['pickup', 'delivery', 'stop']);
export const factSchema = z.object({ k: z.string(), v: z.string() });
//# sourceMappingURL=artifact-parts.js.map